import { render, staticRenderFns } from "./SVG.vue?vue&type=template&id=509d4216&scoped=true&"
import script from "./SVG.vue?vue&type=script&lang=js&"
export * from "./SVG.vue?vue&type=script&lang=js&"
import style0 from "./SVG.vue?vue&type=style&index=0&id=509d4216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d4216",
  null
  
)

export default component.exports